import { axios } from '../../services/axios';

export default async function getSRTTrunkNewPassword(trunkId) {
    const result = await axios.get(`/Trunk/${trunkId}/NewSipPassword`);
    return result;
}
